import React from "react";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./Pages/store";
import HomePage from "./Pages/HomePage";
import Drughome from "./Pages/Drughome";
import Antimalaria from "./Pages/Antimalaria";
import Cart from "./Pages/Cart";
import Checkout from "./Pages/Checkout";
import Productdetails from "./Pages/Productdetails";
import Contact from "./Pages/Contact";
import Chatwithapharm from "./Pages/Chatwithapharm";
import Aboutus from "./Pages/Aboutus";
import Termsandconditions from "./Pages/Termsandconditions";
import Privacypolicy from "./Pages/Privacypolicy";
import Refundpolicy from "./Pages/Refundpolicy";
import Paediatrics from "./Pages/Paediatrics";
import Allergies from "./Pages/Allergies";
import Analgesics from "./Pages/Analgesics";
import AntiInfectives from "./Pages/AntiInfectives";
import Cardio from "./Pages/Cardio";
import Consumables from "./Pages/Consumables";
import Contraceptives from "./Pages/Contraceptives";
import Cough from "./Pages/Cough";
import Creams from "./Pages/Creams";
import Diabetics from "./Pages/Diabetics";
import Eye from "./Pages/Eye";
import Gastro from "./Pages/Gastro";
import Haematinics from "./Pages/Haematinics";
import Multivitamins from "./Pages/Multivitamins";
import Supplements from "./Pages/Supplements";
import Thankyou from "./Pages/Thankyou";

const App = () => {
  return (
    <Provider store={store}>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/drugs" element={<Drughome />} />
          <Route path="/antimalaria" element={<Antimalaria />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/Productdetails/:ID" element={<Productdetails />} />
          <Route path="*" element={<div>Page Not Found</div>} />
          <Route path="/Contact" element={<Contact />} />
          <Route path="/Chatwithapharm" element={<Chatwithapharm />} />
          <Route path="/Aboutus" element={<Aboutus />} />
          <Route path="/Termsandconditions" element={<Termsandconditions />} />
          <Route path="/Privacypolicy" element={<Privacypolicy />} />
          <Route path="/Refundpolicy" element={<Refundpolicy />} />
          <Route path="/Paediatrics" element={<Paediatrics />} />
          <Route path="/Allergies" element={<Allergies />} />
          <Route path="/Analgesics" element={<Analgesics />} />
          <Route path="/AntiInfectives" element={<AntiInfectives />} />
          <Route path="/Cardio" element={<Cardio />} />
          <Route path="/Consumables" element={<Consumables />} />
          <Route path="/Contraceptives" element={<Contraceptives />} />
          <Route path="/Cough" element={<Cough />} />
          <Route path="/Creams" element={<Creams />} />
          <Route path="/Diabetics" element={<Diabetics />} />
          <Route path="/Eye" element={<Eye />} />
          <Route path="/Gastro" element={<Gastro />} />
          <Route path="/Haematinics" element={<Haematinics />} />
          <Route path="/Multivitamins" element={<Multivitamins />} />
          <Route path="/Supplements" element={<Supplements />} />
          <Route path="/Thankyou" element={<Thankyou />} />
        </Routes>
      </Router>
    </Provider>
  );
};

export default App;
